import React from 'react'
import AddLayerList from './AddLayerList'
import Tooltip from '@material-ui/core/Tooltip';
import CheckBoxAddLayerFile from './CheckboxFIle';
import {addLayerFile} from '../redux';
import { connect } from 'react-redux';

function AddLayerListFile(props){
    
    
    /*  const [data,setData] = React.useState([])

    React.useEffect(()=>{
        var arrayData = []
        
         props.data.data.find(element => {const a = element.children.find(x=>x.name==="Name") 
         if (a!== undefined){ arrayData.push(a)}})
        setData(arrayData)
    },[props.data])  */




     /* const row = (value,dataLayer,index) =>{
        return <Tooltip title={value} key={index}><tr key={index}><td className={"listRow"}>{value}</td><td><CheckBoxAddLayerFile value={value} dataLayer={dataLayer}/></td></tr></Tooltip>
    } 
 */
    /* if(props.layerFile.layerFile === null){return <div><CheckBoxAddLayerFile/></div>} else{ */
    return ( <div className="container">
    <div className="row">
      <div className="col s12 board">
        <table id="simple-board">
        <tbody>
            <tr>
                <td>{/* { props.layerFile.layerFile.file.name} */} </td>
                <td></td>
                <td></td>
                <td><CheckBoxAddLayerFile/></td>
            </tr>
            
            {/* {data.map((x,index)=>row(x.value,props.data.url,index))} */}
             </tbody>
         </table>
      </div>
    </div>
  </div>)


}
const mapStateToProps = state => {
    return {
        layerFile: state.layerFile
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
      addLayerFile: (layerFile) => dispatch(addLayerFile(layerFile))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(AddLayerListFile)